import {
  approveMiscPurchaseOrderAmendment,
  deleteMiscPurchaseOrderAmendment,
  fetchMiscPurchaseOrderAmendmentDetail,
  rejectMiscPurchaseOrderAmendment,
  submitMiscPurchaseOrderAmendment,
} from '#/api/srm/miscPurchaseOrder/amendment';
import { fetchMiscPurchaseOrderPaymentPlan } from '#/api/srm/miscPurchaseOrder/fetchPaymentPlan';
import {
  approvePurchaseOrderAmendment,
  deletePurchaseOrderAmendment,
  fetchPurchaseOrderAmendmentDetail,
  rejectPurchaseOrderAmendment,
  submitPurchaseOrderAmendment,
} from '#/api/srm/purchaseOrder/amendment';
import { fetchPurchaseOrderPaymentPlan } from '#/api/srm/purchaseOrder/fetchPaymentPlan';
import { PERM } from '#/config/permissions';
import { ROUTES } from '#/config/routes';
import {
  getMiscPurchaseOrderApiErrorMessage,
  isMiscPurchaseOrderVersionConflict,
} from '#/modules/srmMgmt/miscPurchaseOrder/helper/apiError';
import {
  getPurchaseOrderApiErrorMessage,
  isPurchaseOrderVersionConflict,
} from '#/modules/srmMgmt/purchaseOrder/helper/apiError';
import {
  miscPurchaseOrderDetailQueryKey,
  miscPurchaseOrderListQueryKeyPrefix,
  purchaseOrderDetailQueryKey,
  purchaseOrderListQueryKeyPrefix,
} from '#/utils/queryKeys';

import { PURCHASE_AMENDMENT_KIND } from './purchaseAmendmentKind';

export { PURCHASE_AMENDMENT_KIND };

/**
 * 兩種採購單異動 UI 共用元件的差異設定（API、路由、權限、快取 key、錯誤訊息）。
 * 物料採購的明細快照以 `mtrId` 對應；非庫存採購以 `lineId`／品名。
 */
const KIND_CONFIG = {
  [PURCHASE_AMENDMENT_KIND.PURCHASE_ORDER]: {
    kind: PURCHASE_AMENDMENT_KIND.PURCHASE_ORDER,
    label: '物料採購單',
    updatePerm: PERM.PURCHASE_ORDER_UPDATE,
    reviewPerm: PERM.PURCHASE_ORDER_REVIEW,
    detailRoute: ROUTES.purchaseOrderDetail,
    editRoute: ROUTES.purchaseOrderAmendmentEdit,
    detailQueryKey: purchaseOrderDetailQueryKey,
    listQueryKeyPrefix: purchaseOrderListQueryKeyPrefix,
    fetchAmendmentDetail: fetchPurchaseOrderAmendmentDetail,
    fetchPaymentPlan: fetchPurchaseOrderPaymentPlan,
    deleteAmendment: deletePurchaseOrderAmendment,
    submitAmendment: submitPurchaseOrderAmendment,
    approveAmendment: approvePurchaseOrderAmendment,
    rejectAmendment: rejectPurchaseOrderAmendment,
    getErrorMessage: getPurchaseOrderApiErrorMessage,
    isVersionConflict: isPurchaseOrderVersionConflict,
  },
  [PURCHASE_AMENDMENT_KIND.MISC_PURCHASE_ORDER]: {
    kind: PURCHASE_AMENDMENT_KIND.MISC_PURCHASE_ORDER,
    label: '非庫存採購單',
    updatePerm: PERM.MISC_PURCHASE_ORDER_UPDATE,
    reviewPerm: PERM.MISC_PURCHASE_ORDER_REVIEW,
    detailRoute: ROUTES.miscPurchaseOrderDetail,
    editRoute: ROUTES.miscPurchaseOrderAmendmentEdit,
    detailQueryKey: miscPurchaseOrderDetailQueryKey,
    listQueryKeyPrefix: miscPurchaseOrderListQueryKeyPrefix,
    fetchAmendmentDetail: fetchMiscPurchaseOrderAmendmentDetail,
    fetchPaymentPlan: fetchMiscPurchaseOrderPaymentPlan,
    deleteAmendment: deleteMiscPurchaseOrderAmendment,
    submitAmendment: submitMiscPurchaseOrderAmendment,
    approveAmendment: approveMiscPurchaseOrderAmendment,
    rejectAmendment: rejectMiscPurchaseOrderAmendment,
    getErrorMessage: getMiscPurchaseOrderApiErrorMessage,
    isVersionConflict: isMiscPurchaseOrderVersionConflict,
  },
};

export function getPurchaseAmendmentKindConfig(kind) {
  return KIND_CONFIG[kind] ?? KIND_CONFIG[PURCHASE_AMENDMENT_KIND.PURCHASE_ORDER];
}
